module.exports = __webpack_public_path__ + "img/skills.a08c7e6d.png";